import { ValueContainerProps, components } from 'react-select';
import { OptionType } from '..';

export default function CustomValueContainer(props: ValueContainerProps<OptionType, true>){
	const selected = props.getValue();
	const count = selected.length;

	return (
		<components.ValueContainer {...props}>
			{count > 0 && (
				<span style={{ marginRight: 8 }}>
					{count} selected
				</span>
			)}
			{props.children}
		</components.ValueContainer>
	);
}